/**
 * GTCH-853. Reads the market-restriction refusal off an API error.
 *
 * The API answers 403 with { data: { reason } } when a want-listing cannot be
 * created or re-activated because its market is served by the Buyer Listing
 * Service. Everything else is an ordinary failure and should keep its existing
 * handling.
 *
 * Returns 'MARKET_RESTRICTED' | 'POLICY_LOCKED' | null.
 */
export const MARKET_RESTRICTED = "MARKET_RESTRICTED";
export const POLICY_LOCKED = "POLICY_LOCKED";

const REASONS = [MARKET_RESTRICTED, POLICY_LOCKED];

export const getMarketRestrictedReason = (error) => {
  // Thrown axios error, or a resolved payload passed straight through.
  const reason =
    error?.response?.data?.data?.reason ??
    error?.data?.reason ??
    error?.reason ??
    null;

  return REASONS.includes(reason) ? reason : null;
};

/**
 * Is this want-listing in a market that has moved to the BLS? Set by the API
 * on want-listing detail and list rows; absent while the gate is off.
 */
export const isMarketRestrictedWantAd = (wantAd) =>
  Boolean(wantAd?.isMarketRestricted ?? wantAd?.IsMarketRestricted);

// Set on every sign-in, consumed by LoginMarketNotice. The event covers
// LoginModal, which signs in without a navigation or reload.
export const LOGIN_MARKET_NOTICE_KEY = "marketNoticePending";
export const LOGIN_MARKET_NOTICE_EVENT = "gitcha:market-notice-pending";

export const flagMarketNoticeOnLogin = () => {
  try {
    localStorage.setItem(LOGIN_MARKET_NOTICE_KEY, "1");
    window.dispatchEvent(new Event(LOGIN_MARKET_NOTICE_EVENT));
  } catch (e) {
    console.warn("Unable to flag the market notice", e);
  }
};

/**
 * User_Details.Location is free text, written by the profile picker as
 * "City, ST". Anything without both parts returns null rather than a guess.
 */
export const parseUserLocation = (location) => {
  const [city, rest] = String(location ?? "")
    .split(",")
    .map((part) => part.trim());
  const state = (rest || "").split(/\s+/)[0];
  return city && state ? { city, state } : null;
};
